import { Grid, Typography, useTheme } from "@mui/material";
import { MprcButton } from "components";
import { MprcProgress } from "components/MprcProgress";
import { AssessmentInstanceDto, AssessmentMode, AssessmentPlayerMode, AssessmentQuestionDto } from "generated/CoreApi_v1";
import { Formaters } from "lib/Formaters";
import React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    viewData: AssessmentInstanceDto;
    question: AssessmentQuestionDto;
    leftTime: number;
    displayTime: number;
    progress: number;
    canNext: boolean;
    sequence: number;
    goNextQuestion: () => void;
    goBackQuestion: () => void;
    goFinish: () => void;
    saveQuestion: () => void;
    onClose: (success: boolean) => void;
}

export const AssPlayerQuestionActions: React.FC<IProps> = (props) => {

    const { viewData, question, sequence, leftTime, displayTime, progress, canNext, goNextQuestion, goBackQuestion, saveQuestion, onClose, goFinish } = props;

    const theme = useTheme();
    const { t } = useTranslation("assessment");

    return (
        <Grid container alignItems="center" spacing={2} marginLeft={1} marginRight={2} marginBottom={1}>
            <Grid>
                <Typography variant="h6" component="span" color={theme.palette.muted.main}>
                    <strong>{t("AssPlayer.Question.ProgressQuestionText", { count: sequence, total: viewData.totalQuestions })}</strong>
                </Typography>
                <MprcProgress
                    value={sequence / viewData.totalQuestions * 100}
                    color="primary"
                    height={17}
                    width={166}
                    backgroundColor="#dadada"
                    border="none"
                />
            </Grid>
            <Grid>
                {
                    viewData.playerMode != AssessmentPlayerMode.UserReview && viewData.playerMode != AssessmentPlayerMode.FinalResult &&
                    leftTime != undefined && leftTime >= 0 && viewData.eval?.timeToComplete != null &&
                    <>
                        <Typography variant="h6" component="span" color={theme.palette.muted.main}>
                            <strong>{t("AssPlayer.Question.ProgressTimeText", { text: Formaters.playTimer(displayTime) })}</strong>
                        </Typography>
                        <MprcProgress
                            value={progress}
                            color={leftTime < 120 ? "error" : leftTime < 300 ? "warning" : "success"}
                            height={17}
                            width={166}
                            backgroundColor="#dadada"
                            border="none"
                        />
                    </>
                }
            </Grid>
            <Grid size="grow">
                {
                    question.revision?.answerPoints != undefined && question.revision?.percentPoints != undefined &&
                    <>
                        <Typography variant="h6" component="span" color={theme.palette.muted.main}>
                            <strong>{t("AssPlayer.Question.AnswerPointsText", { val: question.revision.answerPoints })}</strong>
                        </Typography>
                        <MprcProgress
                            value={question.revision.percentPoints ?? 0}
                            color="success"
                            height={17}
                            width={166}
                            backgroundColor="#dadada"
                            border="none"
                        />
                    </>
                }
                {
                    question.revision?.averagePoints != undefined && question.revision?.percentPoints != undefined && question.revision.totalPoints != undefined &&
                    <>
                        <Typography variant="h6" component="span" color={theme.palette.muted.main}>
                            <strong>{t("AssPlayer.Question.AveragePoints", {
                                average: Formaters.number(question.revision?.averagePoints, 1),
                                count: question.revision.totalPoints ?? 0
                            })}</strong>
                        </Typography>
                        <MprcProgress
                            value={question.revision.percentPoints ?? 0}
                            color="success"
                            height={17}
                            width={166}
                            backgroundColor="#dadada"
                            border="none"
                        />
                    </>
                }
            </Grid>
            <Grid>
                {
                    (viewData.playerMode == AssessmentPlayerMode.UserReview || viewData.playerMode == AssessmentPlayerMode.FinalResult
                        || (sequence > 1 && (viewData.eval?.allowGoback || viewData.mode == AssessmentMode.Survey))) &&
                    <MprcButton
                        variant="contained"
                        color="muted"
                        text={t("AssPlayer.Question.BackButtonText")}
                        title={t("AssPlayer.Question.BackButtonTitle")}
                        onClick={() => goBackQuestion()}
                    />
                }
            </Grid>
            {
                (viewData.mode != AssessmentMode.Challenge || question.revision != null) &&
                <Grid>
                    {
                        viewData.totalQuestions == sequence && viewData.playerMode != AssessmentPlayerMode.UserReview && viewData.playerMode != AssessmentPlayerMode.FinalResult
                            ?
                            <MprcButton
                                variant="contained"
                                color="success"
                                text={t("AssPlayer.Question.FinishButtonText")}
                                title={t("AssPlayer.Question.FinishButtonTitle")}
                                disabled={!canNext}
                                onClick={() =>
                                    viewData.mode == AssessmentMode.Challenge
                                        ? goFinish()
                                        : (viewData.playerMode == AssessmentPlayerMode.UserReview || viewData.playerMode == AssessmentPlayerMode.FinalResult)
                                            ? onClose(false)
                                            : saveQuestion()
                                }
                            />
                            :
                            viewData.mode == AssessmentMode.Challenge
                                ?
                                <MprcButton
                                    variant="contained"
                                    color="warning"
                                    text={t("AssPlayer.Question.NextQuestionButtonText")}
                                    title={t("AssPlayer.Question.NextQuestionButtonTitle")}
                                    disabled={!canNext}
                                    onClick={() => goNextQuestion()}
                                />
                                :
                                <MprcButton
                                    variant="contained"
                                    color="primary"
                                    text={t("AssPlayer.Question.NextButtonText")}
                                    title={t("AssPlayer.Question.NextButtonTitle")}
                                    disabled={!canNext}
                                    onClick={() =>
                                        (viewData.playerMode == AssessmentPlayerMode.UserReview || viewData.playerMode == AssessmentPlayerMode.FinalResult) && viewData.totalQuestions == sequence
                                            ? goFinish()
                                            : (viewData.mode == AssessmentMode.Challenge || viewData.playerMode == AssessmentPlayerMode.UserReview || viewData.playerMode == AssessmentPlayerMode.FinalResult)
                                                ? goNextQuestion()
                                                : saveQuestion()}
                                />
                    }
                </Grid>
            }
        </Grid>
    );
};
